package app.smartcoding.realrate.domain.model.creditCardField

import androidx.compose.ui.text.input.TextFieldValue

sealed interface MonthsField : Field {
    data class MonthsTotal(override val textFieldValue: TextFieldValue, override val delta: Double) : MonthsField
    data class Years(override val textFieldValue: TextFieldValue, override val delta: Double) : MonthsField
    data class Months(override val textFieldValue: TextFieldValue, override val delta: Double) : MonthsField
}